import { FooterWrapper } from "../styles/footer";

const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <footer>
        <div className="footer">
          <div className="footer--logo reveal active">
            <a href="/#"><img style={{ width: '200px' }} src="footer-logo.png" alt="" /></a>
          </div>
          <div className="footer--content reveal active">
            <div className="footer--content__span reveal active">
              <span className="fonthero" style={{ color: 'white', fontSize: '24px' }}>STAY CONNECTED</span>
            </div>
            <div className="footer--content__social reveal active">
              <a href="https://twitter.com/HeroesChained" target="_blank" rel="noreferrer"><i className="icon-social twitter" /></a>
              <a href="https://instagram.com/heroeschained" target="_blank" rel="noreferrer"><i className="icon-social instagram" /></a>
              <a href="https://www.youtube.com/channel/UCtzpPOus-v3G0eFk_GSZG3A" target="_blank" rel="noreferrer"><i className="icon-social youtube" /></a>
              <a href="https://medium.com/@heroeschained" target="_blank" rel="noreferrer"><i className="icon-social medium" /></a>
              <a href="https://discord.com/invite/heroeschained" target="_blank" rel="noreferrer"><i className="icon-social discord" /></a>
              <a href="https://t.me/HeroesChainedOfficial" target="_blank" rel="noreferrer"><i className="icon-social telegram" /></a>
            </div>
            <div className="footer--content__menu">
              <ul style={{ paddingLeft: '0px !important' }}>
                <li style={{ listStyleType: 'none' }}><a href="https://whitepaper.heroeschained.com/" target="_blank" rel="noreferrer">Whitepaper</a></li>
                <li style={{ listStyleType: 'none' }}><a href="https://heroeschained.com/assets/HC_Litepaper.pdf" target="_blank" rel="noreferrer">Litepaper</a></li>
                <li style={{ listStyleType: 'none' }}><a href="https://heroeschained.com/#roadmap" target="_blank" id="roadmap-button" rel="noreferrer">Roadmap</a></li>
              </ul>
            </div>
            <div className="footer--content__terms">
              <ul style={{ paddingLeft: '0px !important' }}>
                <li><a href="https://heroeschained.com/terms-of-service/">Terms of Service</a></li>
                <li><a href="https://heroeschained.com/privacy-policy/">Privacy Policy</a></li>
              </ul>
            </div>
          </div>
          <div className="chain">
            <div className="chain--one" />
            <div className="chain--two" />
            <div className="chain--three" />
          </div>
        </div>
      </footer>
    </FooterWrapper>
  )
}

export default Footer;
